import HomeLayout from '../../../../components/Layouts/BrowserLayouts/HomeLayout/HomeLayout';

import JobHub from '../../../../components/UserDashboard/JobHub/JobHub';

const RenderComponent = () => {
  return ( <JobHub /> )
}

RenderComponent.Layout = HomeLayout;

export default RenderComponent